import {
  getMaterialLink,
  isExpertMaterial,
} from '~/shared/lib/getMaterialLink';

/*
  Мнение эксперта — не отдельная сущность, а тип материала: чтение, создание,
  редактирование и удаление идут одной ручкой /admin/materials/, адресация
  по pk. Ручки /admin/experts/ и /main/experts/ удалены и отвечают 404.

  Здесь осталось только то, что у мнений всё ещё своё:
    - публичная ссылка строится по expert_url_id, а не по pk;
    - лид и корневой тег обязательны у всех типов, кроме мнения.
*/

export type AdminMaterialType = 'news' | 'analytics' | 'new_object' | 'expert';

/* Тип мнения. На чтение бэкенд всегда отдаёт единственное число. */
export const EXPERT_MATERIAL_TYPE = 'expert';

/*
  На запись бэкенд принимает и 'expert', и 'experts', на чтение отдаёт
  только 'expert'; проверку обоих написаний держим в общем хелпере.
*/
export const isExpertMaterialType = isExpertMaterial;

/* Ссылка на материал на сайте: у мнений — /expert/<публичный номер>. */
export const getMaterialPublicPath = getMaterialLink;

/*
  Лид и корневой тег бэкенд требует у всех типов, кроме мнения. Бэкенд
  проверяет фактический тип записи после сохранения, поэтому валидацию
  на форме привязываем к выбранному в ней типу.
*/
export const isRequiredForNonExpertType = (
  type: string | null | undefined,
): boolean => !isExpertMaterialType(type);
